var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    theme: 'tooltip-top-left',
    content: _vm.tooltip
  }),expression:"{\n    theme: 'tooltip-top-left',\n    content: tooltip\n  }"}],staticClass:"button",class:{ 'button--loading': _vm.isLoading },on:{"click":function($event){$event.preventDefault();return _vm.updateTracking.apply(null, arguments)}}},[_c(_vm.icon,{tag:"Component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }